<template lang="pug">
	table.table.table-striped.m-0
		thead
			tr
				th Programa
		tbody
			tr(v-for="programa in listadoProgramas", @click="seleccionaPrograma(programa)", :class="colocacion.ProgramaID === programa.ProgramaID ? 'bg-danger text-white' : ''", style="cursor:pointer;")
				td {{programa.Nombre}}
</template>

<script>
export default {
	props: ['EmisoraID', 'colocacion'],
	data () {
		return {
			listadoProgramas: []
	   }
	},
	created () {
		// Obtenemos los programas de esa emisora
		this.$http.post('gestion-emisoras/php/api/programas/buscar-programas.php', {EmisoraID: this.EmisoraID})
			.then(res => {
				this.listadoProgramas = res.data
			})
			.catch(this.$responseError)
	},
	methods: {
		seleccionaPrograma (programa) {
			this.colocacion.ProgramaID = programa.ProgramaID
			this.colocacion.ProgramaNombre = programa.Nombre
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/colocacion/programa.vue